import { CountryCode, CurrencyCode } from "../common/enums";

import { formatFunc, format2objectFunc } from "./formatRules";

/**
 * @name 旧版转化金额的方法
 * @param {string} currencyCode 货币符号
 * @param {number|string} value 金额
 * @param {string} format 默认"shortprice" "shortprice"(缩写) | "price"(全显)
 * @param {boolean} needCurrencyCode 是否需要显示货币符号 默认 true
 */
export function oldFormatPrice(
  countryCode = CountryCode.ID,
  value?: number | string,
  format: "shortprice" | "price" = "shortprice",
  needCurrencyCode = true
): string | number {
  return formatFunc({ countryCode, value, format, needCurrencyCode });
}

/**
 * @name 新版转化金额方法
 * @param {Object} options
 * 参数描述
 * - {string} currencyCode 货币符号
 * - {number|string} value 金额
 * - {string} format 默认"shortprice" "shortprice"(缩写) | "price"(全显)
 * - {boolean} needCurrencyCode 是否需要显示货币符号 默认 true
 */
export function newFormatPrice({
  countryCode = CountryCode.ID,
  value,
  format = "shortprice",
  needCurrencyCode = true,
}: {
  countryCode: CountryCode;
  value?: number | string;
  format?: "price" | "shortprice";
  needCurrencyCode?: boolean;
}): string | number {
  return formatFunc({ countryCode, value, format, needCurrencyCode });
}

/**
 * @name 转化金额方法, 返回object
 * @param {Object} options
 * 参数描述
 * - {string} currencyCode 货币符号
 * - {number|string} value 金额
 * - {string} format 默认"shortprice" "shortprice"(缩写) | "price"(全显)
 * - {boolean} needCurrencyCode 是否需要显示货币符号 默认 true
 * @return {Object} obj
 * - {string} currencyCode 货币符号
 * - {string} value 金额
 * - {string} unit 缩写单位
 */
export function formatPrice2object({
  countryCode = CountryCode.ID,
  value,
  format = "shortprice",
}: {
  countryCode: CountryCode;
  value?: number | string;
  format?: "price" | "shortprice";
}): {
  currencyCode: CurrencyCode;
  value?: string | number;
  unit?: string;
  posAtRight?: boolean;
  separator?: string;
  pointStr?: string;
} {
  return format2objectFunc({ countryCode, value, format });
}
